import React from 'react';

export const TodoistSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-259.5"
				y="-263.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#DE483A"
			/>
			<path
				d="M22.3534 6.68774H9.68868C8.04291 6.68774 6.70874 8.02192 6.70874 9.6677V22.3325C6.70874 23.9783 8.04291 25.3125 9.68868 25.3125H22.3534C23.9992 25.3125 25.3334 23.9783 25.3334 22.3325V9.6677C25.3334 8.02192 23.9992 6.68774 22.3534 6.68774Z"
				fill="white"
			/>
			<path
				d="M10.6452 15.4139L14.355 13.2791L14.3596 13.2762L18.1824 11.0761C18.3436 10.983 18.3511 10.6978 18.1707 10.5942L18.0444 10.522C17.8599 10.4173 17.6213 10.2811 17.5194 10.2217C17.4302 10.1731 17.33 10.1482 17.2284 10.1495C17.1268 10.1507 17.0272 10.178 16.9392 10.2287C16.849 10.2811 10.8274 13.7429 10.626 13.8576C10.5073 13.9254 10.373 13.9611 10.2363 13.9611C10.0996 13.9611 9.96533 13.9254 9.84666 13.8576L6.6665 12.0097V13.5806L6.6991 13.5992C7.49297 14.0619 9.37173 15.1561 9.83153 15.4151C10.1103 15.5722 10.3769 15.5687 10.6452 15.4139Z"
				fill="#DE483A"
			/>
			<path
				d="M10.6452 18.5522L14.3503 16.4197L14.3643 16.4116L18.1824 14.2144C18.3436 14.1213 18.3511 13.8355 18.1707 13.7325L18.0444 13.6603C17.8605 13.5556 17.6213 13.4194 17.5194 13.36C17.4302 13.3114 17.33 13.2865 17.2284 13.2878C17.1268 13.289 17.0272 13.3163 16.9392 13.367C16.849 13.4188 10.8274 16.8812 10.626 16.9953C10.5073 17.0632 10.373 17.0988 10.2363 17.0988C10.0996 17.0988 9.96533 17.0632 9.84666 16.9953C9.65692 16.8859 6.6665 15.148 6.6665 15.148V16.7183L6.6991 16.7375C7.49355 17.2002 9.37173 18.2938 9.83153 18.5534C10.1103 18.7105 10.3769 18.7071 10.6452 18.5522Z"
				fill="#DE483A"
			/>
			<path
				d="M14.3556 19.5552L10.6452 21.6906C10.3769 21.8455 10.1097 21.8489 9.83153 21.6918C9.37174 21.4322 7.49356 20.3386 6.6991 19.8759L6.6665 19.8567V18.2864L9.84666 20.1337C10.087 20.2728 10.385 20.2711 10.626 20.1337C10.8274 20.0196 16.849 16.5572 16.9392 16.5048C17.0272 16.4541 17.1268 16.4268 17.2284 16.4256C17.33 16.4244 17.4302 16.4492 17.5194 16.4978C17.7361 16.6231 17.9534 16.7473 18.1713 16.8703C18.3517 16.9739 18.3436 17.2597 18.1824 17.3528L14.3556 19.5552Z"
				fill="#DE483A"
			/>
		</svg>
	);
};
